import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useVoidCheckQuery = (onSuccess: () => void, id?: string) => {
  const { mutateAsync, isLoading } = useMutation(
    (reason?: string) =>
      api.put(API_URL.CHECKS_VOID_BY_CHECK_ID(id || ''), {
        ...(reason ? { void_reason: reason } : {}),
      }),
    { onSuccess }
  );
  return {
    mutateAsync,
    isLoading,
  };
};

export default useVoidCheckQuery;
